import React from "react";
import { Input } from "./ui/input";
import { Icons } from "./ui/icons";
import MobileSearchField from "./mobile/mobile-search-field";
import { useIsMobile } from "../hooks/use-is-mobile";

interface SearchInputProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
}

const SearchInput: React.FC<SearchInputProps> = ({
  searchTerm,
  onSearchChange,
  placeholder = "Search items...",
  className = "",
  disabled = false,
}) => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <MobileSearchField
        value={searchTerm}
        onChange={onSearchChange}
        placeholder={placeholder}
        disabled={disabled}
      />
    );
  }

  return (
    <div className={`flex-1 max-w-md relative ${className}`}>
      <div className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none">
        <Icons.Search className="h-4 w-4" />
      </div>
      <Input
        type="text"
        placeholder={placeholder}
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
        disabled={disabled}
        className="h-9 bg-gray-50/50 border-0 ring-0 focus:ring-0 pl-10"
      />
    </div>
  );
};

export default SearchInput;
